import styled from "styled-components";
import Button from "../../shared/styledComponents/Button";

const StyledButton = styled(Button)`
  min-height: 50px;
  margin-top: 15px;
  flex-grow: 1;
  max-width: 45%;
`;

export default StyledButton;
